import { createAction } from "redux-actions";

import { moduleSlug } from "../constants";

export const clearUsersRoles = createAction(`${moduleSlug}/CLEAR_USERS_ROLES`);

export const getUsersRoles = createAction(`${moduleSlug}/GET_USERS_ROLES`);
export const getUsersRolesSuccess = createAction(`${moduleSlug}/GET_USERS_ROLES/SUCCESS`);
export const getUsersRolesError = createAction(`${moduleSlug}/GET_USERS_ROLES/ERROR`);

export const getRoleByID = createAction(`${moduleSlug}/GET_ROLE_BY_ID`);
export const getRoleByIDSuccess = createAction(`${moduleSlug}/GET_ROLE_BY_ID/SUCCESS`);
export const getRoleByIDError = createAction(`${moduleSlug}/GET_ROLE_BY_ID/ERROR`);

export const createRole = createAction(`${moduleSlug}/CREATE_ROLE`);
export const createRoleSuccess = createAction(`${moduleSlug}/CREATE_ROLE/SUCCESS`);
export const createRoleError = createAction(`${moduleSlug}/CREATE_ROLE/ERROR`);

export const updateRole = createAction(`${moduleSlug}/UPDATE_ROLE`);
export const updateRoleSuccess = createAction(`${moduleSlug}/UPDATE_ROLE/SUCCESS`);
export const updateRoleError = createAction(`${moduleSlug}/UPDATE_ROLE/ERROR`);

export const deleteRole = createAction(`${moduleSlug}/DELETE_ROLE`);
export const deleteRoleSuccess = createAction(`${moduleSlug}/DELETE_ROLE/SUCCESS`);
export const deleteRoleError = createAction(`${moduleSlug}/DELETE_ROLE/ERROR`);

export const getActionsForRole = createAction(`${moduleSlug}/GET_ACTIONS_FOR_ROLE`);
export const getActionsForRoleSuccess = createAction(`${moduleSlug}/GET_ACTIONS_FOR_ROLE/SUCCESS`);
export const getActionsForRoleError = createAction(`${moduleSlug}/GET_ACTIONS_FOR_ROLE/ERROR`);